import ButtonTabs from "@components/ButtonTabs/ButtonTabs";
import DateStripDatepicker from "@components/shared/DateStripDatepicker/DateStripDatepicker";
import { CalendarHeaderProps } from "@models/components/kiosk.model";
import { ResourceInfoType } from "@models/components/units.model";
import { locationType } from "@models/services/organisation";

import DateStrip from "../DateStrip/DateStrip";

const CalendarHeader = ({
  locationDetails,
  onTabChange,
  selectedTab,
}: CalendarHeaderProps) => {
  return (
    <>
      <div className="fg-booking-header" data-testid="booking-header-test">
        <div className="fg-location-block">
          <ButtonTabs
            tabs={locationDetails?.locations}
            selectedTab={selectedTab}
            handleTabChange={
              onTabChange as (tab: locationType | ResourceInfoType) => void
            }
          />
        </div>
        <div className="fg-booking-header-right">
          <DateStripDatepicker />
        </div>
      </div>
      <div className="fg-booking-header-date-strip">
        <DateStrip />
      </div>
    </>
  );
};

export default CalendarHeader;
